<template>
  <list mode="dataset" :items="datasets" @load="onLoad" @delete="onDelete" />
</template>
<script>
import List from "@/components/list"
import Datasets from "@/api/datasets"
export default {
  name: "Datasets",
  components: { List },
  data() {
    return {
      datasets: {
        limit: 20,
        offset: 0,
        count: 0,
        results: []
      }
    }
  },
  methods: {
    onLoad() {
      if (this.datasets.count == 0 || this.datasets.offset < this.datasets.count) {
        this.setBusy(true)
        Datasets.list(this.datasets.offset).then(response => {
          this.datasets.count = response.data.count
          this.datasets.results.push(...response.data.results)
          this.datasets.offset += this.datasets.limit
        }).finally(() => this.setBusy(false))
      }
    },
    onDelete(items) {
      Datasets.delete({ items: items }).then(response => {
        this.notify(response.data)
        this.refresh()
      })
    }
  }
}
</script>
